
<div   class="canvasEditor d-flex justify-content-center align-items-center" (click)="editDiagram()">
<img   class="canv-image" id="canvasEditor" #canvasEditor />
</div>
